import { Check, CreditCard, Smartphone, Watch } from 'lucide-react';

const TERMINAL_IMG = process.env.REACT_APP_TERMINAL_IMG_1 || '/images/terminal-card.jpeg';
const MUURBEVESTIGING_IMG = 'https://customer-assets-v7afamib.emergentagent.net/job_66d3fe9a-83be-47c0-9138-c2cc60c5236a/artifacts/ps0a8m5o_IMG_9217.JPG';

const cur = (v) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v);

export function ProductsSection() {
    return (
        <section id="products" className="py-16 lg:py-24 px-4 bg-[#FBF7EE]" data-testid="products-section">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                    <span className="inline-block px-4 py-1.5 bg-[#3D3B00] text-[#F5ECD7] text-sm font-semibold rounded-full mb-4">Producten</span>
                    <h2 className="text-3xl sm:text-4xl font-bold text-[#3D3B00] font-['Outfit'] mb-3 tracking-tight">
                        Wat u koopt of least
                    </h2>
                    <p className="text-[#3D3B00]/70 max-w-2xl mx-auto">
                        De Adyen S1U2 pinterminal met muurbevestiging. Compleet pakket, direct te installeren.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                    {/* Pinterminal */}
                    <div className="bg-white rounded-2xl border border-[#3D3B00]/10 shadow-sm overflow-hidden flex flex-col" data-testid="product-pinterminal">
                        <div className="aspect-[16/10] bg-[#F5ECD7]/40 flex items-center justify-center overflow-hidden">
                            <img src={TERMINAL_IMG} alt="Adyen S1U2 pinterminal productfoto excl. muurbevestiging" className="w-full h-full object-cover" loading="lazy" />
                        </div>
                        <div className="p-6 flex-1 flex flex-col">
                            <div className="flex items-start justify-between mb-3">
                                <div>
                                    <h3 className="text-xl font-bold text-[#3D3B00] font-['Outfit']">Pinterminal Adyen S1U2</h3>
                                    <p className="text-sm text-[#3D3B00]/60">Contactloos, IP65 waterdicht, 4G</p>
                                </div>
                                <div className="text-right flex-shrink-0">
                                    <div className="text-2xl font-bold text-[#3D3B00] font-['Outfit']">{cur(699)}</div>
                                    <div className="text-xs text-[#3D3B00]/50">excl. btw, per stuk</div>
                                </div>
                            </div>
                            <ul className="space-y-2 mt-3 mb-4 text-sm text-[#3D3B00]/75">
                                {[
                                    'Pinpas, creditcard, Apple Pay, Google Pay',
                                    'PCI gecertificeerd betaalverkeer',
                                    'Live dashboard voor tarieven en omzet',
                                    'Pre-authorization (gasten betalen wat ze gebruiken)',
                                ].map((f) => (
                                    <li key={f} className="flex items-start gap-2">
                                        <Check className="w-4 h-4 text-[#4CAF50] mt-0.5 flex-shrink-0" />
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-auto flex flex-wrap gap-2 pt-4 border-t border-[#3D3B00]/10">
                                {[
                                    { icon: CreditCard, label: 'Pin' },
                                    { icon: Smartphone, label: 'Apple Pay' },
                                    { icon: Smartphone, label: 'Google Pay' },
                                    { icon: Watch, label: 'Smartwatch' },
                                ].map((m) => (
                                    <div key={m.label} className="flex items-center gap-1.5 px-2 py-1 bg-[#F5ECD7]/50 rounded-lg text-xs text-[#3D3B00]/70">
                                        <m.icon className="w-3 h-3" />
                                        <span>{m.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Muurbevestiging */}
                    <div className="bg-white rounded-2xl border border-[#3D3B00]/10 shadow-sm overflow-hidden flex flex-col" data-testid="product-muurbevestiging">
                        <div className="aspect-[16/10] bg-gradient-to-br from-[#3D3B00]/5 to-[#3D3B00]/15 overflow-hidden">
                            <img
                                src={MUURBEVESTIGING_IMG}
                                alt="Kunststof muurbevestiging met RECRA Solutions logo, precies passend rond de Adyen S1U2"
                                loading="lazy"
                                className="w-full h-full object-cover"
                                data-testid="muurbevestiging-photo"
                            />
                        </div>
                        <div className="p-6 flex-1 flex flex-col">
                            <div className="flex items-start justify-between mb-3">
                                <div>
                                    <h3 className="text-xl font-bold text-[#3D3B00] font-['Outfit']">Muurbevestiging</h3>
                                    <p className="text-sm text-[#3D3B00]/60">Kunststof, perfect passend rond de S1U2</p>
                                </div>
                                <div className="text-right flex-shrink-0">
                                    <div className="text-2xl font-bold text-[#3D3B00] font-['Outfit']">{cur(59)}</div>
                                    <div className="text-xs text-[#3D3B00]/50">excl. btw, per stuk</div>
                                </div>
                            </div>
                            <ul className="space-y-2 mt-3 mb-4 text-sm text-[#3D3B00]/75">
                                {[
                                    'Op maat gemaakt frame, precies rond de S1U2',
                                    'Open zichtvenster voor scherm en contactloos-antenne',
                                    'Robuust mat-zwart kunststof met RECRA logo',
                                    'Snelmontage met vier bevestigingsschroeven',
                                ].map((f) => (
                                    <li key={f} className="flex items-start gap-2">
                                        <Check className="w-4 h-4 text-[#4CAF50] mt-0.5 flex-shrink-0" />
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-auto pt-4 border-t border-[#3D3B00]/10 text-xs text-[#3D3B00]/50">
                                Aanbevolen voor iedere pinterminal in doucheruimtes
                            </div>
                        </div>
                    </div>
                </div>

                <p className="text-center text-sm text-[#3D3B00]/60 mt-8">
                    Combi (koop): <span className="font-semibold text-[#3D3B00]">{cur(699 + 59)}</span> per doucheruimte. Leasen kan al vanaf {cur(39)}/maand per terminal.
                </p>
            </div>
        </section>
    );
}
